// TIER ONE OF THE HEADER: where am I in time.
//
// This is navigation and nothing else — it moves the window, it never changes what the
// window is or who is in it. Those are the view bar's three groups, one tier down
// (CalendarViewBar), and the separation is the point: the header used to run eleven
// identical pills together, so "go to last week" and "show me only Kobi" looked like the
// same kind of act.
//
// THE DATE IS THE DOMINANT ELEMENT HERE, not the buttons. It is the answer to the question
// this group exists to ask, so it carries the weight, and the two arrows FLANK it rather
// than sitting off to one side — that is what makes them read as paging the date rather
// than as two more toggles. `היום` sits apart from the pair as the reset.
import he from '../../i18n/he';
import Button from '../../components/Button';
import DateText, { formatMonthLong } from '../../components/DateText';
import { rangeFor } from './calendarDates';

// What window is on screen, said in words. A month gets its name ("יולי 2026"); a day and
// a week get their dates, because the useful fact there is which days they are.
const Heading = ({ view, anchor }) => {
  if (view === 'month') return <>{formatMonthLong(anchor.slice(0, 7))}</>;
  if (view === 'day') return <DateText value={anchor} />;
  const { from, to } = rangeFor('week', anchor);
  return <><DateText value={from} /> – <DateText value={to} /></>;
};

export default function CalendarNav({ view, anchor, onAnchor, onToday }) {
  return (
    <div className="cal-nav">
      <Button small variant="subtle" onClick={onToday}>{he.calendar.today}</Button>

      <div className="cal-pager">
        {/* In RTL the PREVIOUS window is on the right, which is where ‹ points. The two
            arrows are written either side of the heading so they page the thing between
            them; the RTL flow puts prev on the right and next on the left by itself. */}
        <Button small variant="subtle" onClick={() => onAnchor(-1)} aria-label={he.calendar.prev}>›</Button>
        <span className="cal-heading"><Heading view={view} anchor={anchor} /></span>
        <Button small variant="subtle" onClick={() => onAnchor(1)} aria-label={he.calendar.next}>‹</Button>
      </div>
    </div>
  );
}
